<template>
    <div id="ranking-header" class="header-container">
        <div class="header-bg"></div>
        <div class="filter-container">
            <el-select v-model="filters.quarter" clearable placeholder="LỌC QUÝ" @change="handleFilter">
                <el-option
                    v-for="item in quarterOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="filters.year" clearable placeholder="LỌC NĂM" @change="handleFilter">
                <el-option
                    v-for="item in years"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
        </div>
        <div class="top-ranking">
            <TopRanking
                v-for="(user,index) in topRankingClone"
                :key="index + 'top ranking'"
                :user="user"
                :position="index"
            />
        </div>
    </div>
</template>

<script>
import TopRanking from './TopRanking.vue'
import {quarterOptions} from "../../manage-okrs/model/OkrModel";

export default {
    props: {
        topRanking: {
            type: Array,
            required: true,
            default: () => []
        },
        filterProps: {
            type: Object,
            required: true,
            default: () => {
            }
        }
    },
    data() {
        return {
            filters: {},
            years: [],
            quarterOptions,
        }
    },
    computed: {
        topRankingClone() {
            if (this.topRanking.length === 0) return [{}, {}, {}]
            const list = [...this.topRanking]
            const middleItem = list.find(i => +i.rank === 1)
            const others = list.filter(i => +i.rank !== 1)

            if (list.length === 1) return [{}, list[0], {}]
            if (list.length === 2) return [list[0], list[1], {}]
            return [others[0], middleItem, others[1]]
        }
    },
    components: {TopRanking},
    methods: {
        getYears() {
            const now = new Date()
            const currentYear = now.getFullYear()
            for (let i = 2025; i <= currentYear; i++) {
                this.years.push({
                    id: i,
                    name: `${i}`
                })
            }
        },
        handleFilter() {
            this.$emit('changeFilter', this.filters)
        },
    },
    created() {
        this.getYears()
        this.filters = {...this.filterProps}
    }
}
</script>

<style>
#ranking-header .el-input__inner {
    border-radius: 9999px !important;
    width: 150px;
    background: #503694 !important;
    color: #fff !important;
    text-align: center !important;
}

#ranking-header .el-input__inner::placeholder {
    color: white !important;
    opacity: 1;
}

.header-bg {
    left: 150px; right: 150px;
    position: absolute;
    top: 0; bottom: 0;
    background: url("/media/svg/RankingText.svg") no-repeat;
    object-position: center center;
    background-size: contain;
}

.header-container {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 300px;
    margin-top: 40px;
}

.filter-container {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.top-ranking {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: flex-end;
    justify-content: center;
    margin-top: 50px;
    margin-left: 60px;
    margin-right: 60px;
}
@media (max-width: 1024px) {
    .header-bg {
        left: 80px; right: 80px;
    }
    .top-ranking {
        margin-top: 20px;
        margin-left: 30px;
        margin-right: 20px;
    }
}

@media (max-width: 767px) {
    .top-ranking {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 100px;
        margin-bottom: 30px;
        gap: 20px;
    }
    .header-bg {
        top: 50px; left: 20px; right: 20px;
    }
    .header-container {
        margin-top: 20px;
    }
}
</style>
